import {
  MinorAccessRequestData,
  MinorsTermPayload,
} from '../components/MinorAccessRequestModal/types'

class SendMinorAccessRequest {
  toPersistence(data: MinorAccessRequestData): MinorsTermPayload {
    return {
      nomeResponsavel: data?.guardianName,
      emailResponsavel: data?.guardianEmail,
      grauParentesco: data?.guardianKinship?.key,
      idPaciente: data?.idPatient,
      telefoneResponsavel: data?.guardianCellphone,
      idClinica: data?.idClinic,
      nomePaciente: data?.patientName,
    }
  }
}

export default new SendMinorAccessRequest()
